// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1aQF7","inputWrap":"CustomTip_inputWrap__12AEP"};